<template lang="pug">
  div
    .form-row
      .col-12
        input#edit_calendar_name_input.form-control(
          v-model="calendar_name"
          :placeholder="t('components.calendars.calendar_edit.name')"
        )
    .form-row
      .col-12
        .form-check
          input#calendar_import_input.form-check-input.modal-content-import-input(
            type="checkbox" v-model="is_external")
          label.form-check-label(for="calendar_import")
            | {{ t("components.calendars.calendar_edit.import") }}
    .form-row(v-if="is_external")
      .col-12.modal-content__url-input
        input#calendar_url_text_input.form-control(
          v-model="calendar_url"
          :placeholder="t('components.calendars.calendar_edit.url')"
        )
    .form-row(v-else)
      #color_selector.col-12.modal-content__color-selector
        label.form-check-label.color-selector-label(for="calendar_color_selector")
          | {{ t("components.calendars.calendar_edit.select_color") }}
        input#calendar_color_selector(type="color" v-model="calendar_color")
    #edit_buttons.form-row.modal-content__edit-buttons.mt-3
      button.btn.btn-primary(v-if="update_mode" @click="update")
        | {{ t("components.calendars.calendar_edit.update") }}
      button.btn.btn-primary(v-else @click="save")
        | {{ t("components.calendars.calendar_edit.save") }}
      button.btn.btn-secondary.edit-cancel(@click="cancel")
        | {{ t("cancel") }}
</template>

<script>
  import mixins from "common/mixins"
  import { mapActions } from 'vuex'

  export default {
    mixins: [mixins.translate],
    name: "calendars-calendar-edit-vue",
    props: {
      id: { type: String, default: "" },
      name: { type: String, default: "" },
      type: { type: String, default: "data" },
      url: { type: String, default: "" },
      color: { type: String }
    },
    data() {
      return {
        calendar_name: this.name,
        is_external: this.type == "ics",
        calendar_url: this.url,
        calendar_color: this.color ? this.color : "#3788d8",
      }
    },
    computed: {
      update_mode() {
        return this.id != ""
      },
      calendar_type() {
        return this.is_external ? "ics" : "data"
      }
    },
    methods: {
      save() {
        this.create_calendar({
          name: this.calendar_name,
          type: this.calendar_type,
          url: this.is_external ? this.calendar_url : "",
          color: this.is_external ? "" : this.calendar_color
        })
        this.$emit("end")
      },
      update() {
        this.edit_calendar({
          id: this.id,
          name: this.calendar_name,
          type: this.calendar_type,
          url: this.is_external ? this.calendar_url : "",
          color: this.is_external ? "" : this.calendar_color
        })
        this.$emit("end")
      },
      cancel() {
        this.$emit("end")
      },
      ...mapActions("calendars", ["create_calendar", "edit_calendar"])
    }
  }
</script>
